import {useContext} from 'react';
import {useStateMachine} from 'little-state-machine';
import formSectionData from 'components/forms/reducers/formSectionData';
import {FormState} from 'components/forms/context';

/**
 * Provide access to the state of the FormStateNode context form
 */
export default function useFormPersistence(nodeOverride, merge = true) {
    const {node: contextNode} = useContext(FormState);
    const node = nodeOverride || contextNode;

    const {actions, state} = useStateMachine({update: formSectionData(node, merge)});
    const formState = (state && state.forms && state.forms[node]) || {};

    return {
        updateState: actions.update,
        state: formState,
        formState: state.forms,
        node,
    };
}
